<div mat-dialog-content class="dialog-container">
    <div class="d-flex justify-content-between">
        <h5 class="title mb-3">{{title}}</h5>
        <span class="material-icons close-icon-modal" (click)="onNoClick()">close</span>
    </div>
    <div class="upload-container" *ngIf="!onlyView">
        <div class="col-12 p-0">
            <div class="ng2FileDrop d-flex align-items-center justify-content-between mb-1"
                (drop)="onFileDrop($event)"
                (dragover)="onDragOver($event)"
                (dragleave)="onDragLeave($event)">
                <div class="d-flex align-items-center gap-2">
                    <i class="material-icons upload-icon">file_upload</i>
                    <em>Arraste e solte o áudio aqui</em>
                </div>
                <span class="btn btn-outline-light" (click)="openFileSelector()">
                    SELECIONAR ARQUIVO
                </span>
                <input type="file" accept="audio/*" class="d-none" #audioFileInput (change)="onAudioFileSelected($event)" />
            </div>
            <small class="max-filesize">Tamanho máximo: 20MB</small>
        </div>
    </div>
    <div *ngIf="recording" class="btn btn-audio-recording btn-rounded text-left mt-2">
        <div class="row align-items-center">
            <div class="col-2">
                <i class="material-icons" style="font-size: 18px;">graphic_eq</i>
            </div>
            <div class="col-8">
                <span>{{ currentTimeDate | date:'m:ss' }}</span>
            </div>
            <div class="col-2">
                <i class="material-icons" (click)="stopRecording()" style="font-size: 18px; cursor: pointer;">stop</i>
            </div>
        </div>
    </div>
    <div *ngIf="audioURL && !recording" class="mt-2" style="margin-right: 0;">
        <app-audio-player [audioURL]="audioURL" [duration]="duration || 20"
            [backgroundColor]="'#EBECED'" [inputColor]="'#16B097'">
        </app-audio-player>
    </div>
    <div class="col-12 p-0 mt-3 action-buttons" *ngIf="!onlyView && !audioURL && !savedAudio">
        <div class="d-flex gap-2 flex-wrap align-items-stretch">
            <button type="button" class="btn btn-capture btn-rounded text-white"
                [disabled]="recording"
                (click)="startRecording()">
                <span class="material-icons">mic</span>
                Gravar Áudio
            </button>
            <button type="button" class="btn btn-attach btn-rounded text-white"
                [disabled]="recording"
                (click)="openFileSelector()">
                <span class="material-icons">folder</span>
                Anexar Áudio
            </button>
        </div>
    </div>
    <div class="col-12 p-0 mt-3 action-buttons" *ngIf="(audioURL || savedAudio) && !onlyView">
        <div class="d-flex gap-2 flex-wrap align-items-stretch">
            <button type="button" class="btn btn-white btn-rounded d-flex align-items-center justify-content-center" (click)="removeItem()">
                Deletar áudio
            </button>
            <button type="button" class="btn btn-attach btn-rounded text-white d-flex align-items-center justify-content-center" (click)="saveAudioAndClose()">
                Salvar
            </button>
        </div>
    </div>
</div>
